import { incomeDeleteApi } from "../../api/income/incomeDeleteApi"

type PayloadShape = Parameters<typeof incomeDeleteApi>[0]

export async function incomeDeleteService(payload: PayloadShape, token: string) {
	return await incomeDeleteApi(payload, token)
}
